<template>
    <div class="container">
        <!-- <div class="summary">
            <a-statistic
                title="当前可提现金额（元）"
                :value="data_summary.amount"
                style="margin-right: 50px"
            />

            <a-statistic
                title="处理中的提现金额（元）"
                :value="data_summary.amount_pend"
                style="margin-right: 50px"
            />

            <a-statistic
                title="累计成功提现金额（元）"
                :value="data_summary.amount_succeed"
                style="margin-right: 50px"
            />
        </div> -->
        <div class="toolbar">
            <div class="left-items">
                <a-button class="item" icon="icon icon-home" @click="on_reset" />
                <a-button class="item" ref="refresh" icon="icon icon-reset" @click="load()" />
                <a-divider type="vertical" class="item" />
            </div>

            <div class="right-items">
                <a-input-search placeholder="搜索流水号" enter-button @search="on_search" class="item" v-model="wd" />
            </div>
        </div>

        <div class="main">
            <a-table
                :columns="columns"
                :dataSource="data_source"
                rowKey="id"
                :loading="loading"
                :pagination="pagination"
                @change="on_pagination_change"
                :row-selection="{ selectedRowKeys: selected_row_keys, onChange: on_selection_change }"
                size="middle"
                :scroll="{ x: true }"
            >
                <!-- 截图 -->
                <template slot="screenshot" slot-scope="text, record">
                    <a v-if="text" :href="text" target="_blank">查看</a>
                </template>

                <!-- 状态 -->
                <template slot="status" slot-scope="text, record">
                    <a-tag class="b-tag" color="green" v-if="record.paid_at">已完成</a-tag>
                </template>

                <!-- 申请人 -->
                <template slot="user" slot-scope="text, record">
                    <div class="tbox">
                        <div class="a">
                            {{ record.user ? record.user.name : "-" }}
                        </div>
                        <div class="b">
                            {{ moment(record.created_at * 1000).format("YYYY-MM-DD HH:mm") }}
                        </div>
                    </div>
                </template>

                <!-- 处理人 -->
                <template slot="executor" slot-scope="text, record">
                    <div class="tbox">
                        <div class="a">
                            {{ record.executor ? record.executor.name : "-" }}
                        </div>
                        <div class="b" v-if="record.executed_at">
                            {{ moment(record.executed_at * 1000).format("YYYY-MM-DD HH:mm") }}
                        </div>
                    </div>
                </template>

                <template slot="member" slot-scope="text">
                    <div class="tbox" v-if="text">
                        <div class="a">{{ text.name }}</div>
                        <div class="b">ID：{{ text.id }}</div>
                    </div>
                </template>

                <template slot="remark" slot-scope="text, record">
                    <div class="tbox">
                        <div class="a">{{ text }}</div>
                        <div class="b reject-msg" v-if="record.reject_msg">
                            <a-icon type="exclamation-circle" style="margin-right:2px;" />{{ record.reject_msg }}
                        </div>
                    </div>
                </template>

                <template slot="transaction" slot-scope="text, record">
                    <span style="color:#ff9800" v-if="record.reject_msg"
                        ><a-icon type="exclamation-circle" style="margin-right:4px;" />{{ record.reject_msg }}</span
                    >
                    <span v-else>{{ text }}</span>
                </template>
            </a-table>
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    import common_pagination from "../../../mixins/common_pagination.js";
    import commonjs from "../mixins/common";

    export default {
        mixins: [common_pagination, commonjs],
        data() {
            return {
                path: "/order/recharge",
                data_source: [],
                loading: false,
                selected_record: null,
                wd: null,
                search: { status: "" },
                visible_recharge: false,
                visible_reject: false,
                data_summary: {
                    amount: 0,
                    amount_pend: 0,
                    amount_succeed: 0,
                },
                columns: [
                    {
                        dataIndex: "status",
                        width: 80,
                        title: "充值状态",
                        scopedSlots: {
                            customRender: "status",
                        },
                    },
                    {
                        dataIndex: "transaction_no",
                        width: 180,
                        title: "流水号",
                        align: "center",
                        scopedSlots: {
                            customRender: "transaction",
                        },
                    },
                    {
                        dataIndex: "amount",
                        width: 120,
                        align: "center",
                        title: "充值金额",
                        customRender: (e) => `¥ ${e || "0"}`,
                    },
                    {
                        dataIndex: "channel_text",
                        width: 150,
                        align: "center",
                        title: "充值方式",
                    },
                    {
                        dataIndex: "member_id",
                        width: 120,
                        align: "center",
                        title: "客户ID",
                    },
                    {
                        dataIndex: "member.name",
                        width: 120,
                        align: "center",
                        title: "客户姓名",
                    },
                    {
                        dataIndex: "member.balance",
                        width: 120,
                        align: "center",
                        title: "客户账户余额",
                        customRender: (e) => `¥ ${e || "0"}`,
                    },
                    {
                        dataIndex: "created_at",
                        width: 150,
                        title: "充值时间",
                        align: "center",
                        customRender: (e) => moment(e * 1000).format("YYYY-MM-DD HH:mm"),
                    },
                    {
                        dataIndex: "remark",
                        title: "备注",
                        align: "center",
                        scopedSlots: {
                            customRender: "remark",
                        },
                    },
                ],
            };
        },
        created() {
            this.$store.commit("change_state", {
                name: "sidebar_order",
                value: "recharge",
            });

            this.load();
            this.reset_query();
            //this.load_summary();
        },
        watch: {
            $route() {
                this.reset_query();
                this.load();
            },
        },
        methods: {
            moment,
            load() {
                this.loading = true;

                let new_query = JSON.parse(JSON.stringify(this.$route.query));
                this.$http
                    .get(`/order/recharge?${this.objectToQuery(new_query)}`)
                    .then((res) => {
                        if (res.success) {
                            this.data_source = res.data;
                            this.pagination = {
                                pageSize: res.pagination.per_page,
                                total: res.pagination.total,
                                current: res.pagination.current_page,
                            };
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loading = false;
                    });
            },
            reset_query() {
                let query = this.$route.query;

                this.wd = "wd" in query ? query["wd"] : "";
                this.search.status = Object.prototype.hasOwnProperty.call(query, "status") ? query["status"] : "";
            },
            on_search(e) {
                this.$router.push(`${this.path}?wd=${e}`);
            },
        },
    };
</script>

<style lang="less" scoped>
    .container {
        .summary {
            padding: 16px;
            border-bottom: 1px solid #e8e8e8;
            box-sizing: border-box;
            display: flex;
            align-items: center;
        }

        .reject-msg {
            color: #ff9800;
            font-size: 12px;
            .ph {
                height: 1px;
                width: 24px;
                background: #ff9800;
                margin-top: 4px;
                margin-bottom: 4px;
            }
        }
    }
</style>
